module.exports = __webpack_public_path__ + "img/netent.37a5e878.svg";